/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import EmptyLayout from '@/views/layouts/EmptyLayout.vue';

export default [
    {
        //Sklep
        path: 'store',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            // Zamówienia
            {
                path: 'orders',
                name: 'store-orders',
                meta: { auth: true },
                component: () => import('@/modules/store/sales/orders/views/OrdersList.vue')
            },
            {
                path: 'orders/:id',
                name: 'store-orders-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/sales/orders/views/OrderForm.vue')
            },
            // Cechy
            {
                path: 'properties',
                name: 'store-properties',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties/views/PropertiesList.vue')
            },
            {
                path: 'properties/:id',
                name: 'store-properties-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties/views/PropertyForm.vue')
            },
            {
                path: 'properties/add',
                name: 'store-properties-add',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties/views/PropertyForm.vue')
            },
            {
                path: 'properties/sort',
                name: 'store-properties-sort',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties/views/PropertiesSort.vue')
            },
            {
                path: 'properties/values/sort/:id/:isNumerical',
                name: 'store-properties-values-sort',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties/views/PropertyValuesSort.vue')
            },
            // Grupy cech
            {
                path: 'properties-groups',
                name: 'store-properties-groups',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties-groups/views/PropertiesGroupsList.vue')
            },
            {
                path: 'properties-groups/:id',
                name: 'store-properties-groups-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties-groups/views/PropertiesGroupsForm.vue')
            },
            {
                path: 'properties-groups/add',
                name: 'store-properties-groups-add',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties-groups/views/PropertiesGroupsForm.vue')
            },
            {
                path: 'properties-groups/sort',
                name: 'store-properties-groups-sort',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/properties-groups/views/PropertiesGroupsSort.vue')
            },
            // Producenci
            {
                path: 'producers',
                name: 'store-producers',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/producers/views/ProducersList.vue')
            },
            {
                path: 'producers/:id',
                name: 'store-producers-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/producers/views/ProducerForm.vue')
            },
            {
                path: 'producers/add',
                name: 'store-producers-add',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/producers/views/ProducerForm.vue')
            },
            // Waluty
            {
                path: 'currencies',
                name: 'store-currencies',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/currencies/views/CurrenciesList.vue')
            },
            {
                path: 'currencies/:id',
                name: 'store-currencies-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/currencies/views/CurrencyForm.vue')
            },
            {
                path: 'currencies/add',
                name: 'store-currencies-add',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/currencies/views/CurrencyForm.vue')
            },
            // Kraje
            {
                path: 'countries',
                name: 'store-countries',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/countries/views/CountriesList.vue')
            },
            {
                path: 'countries/:id',
                name: 'store-countries-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/countries/views/CountryForm.vue')
            },
            {
                path: 'countries/add',
                name: 'store-countries-add',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/countries/views/CountryForm.vue')
            },
            // Podatki
            {
                path: 'taxations',
                name: 'store-taxations',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/taxations/views/TaxationsList.vue')
            },
            {
                path: 'countries/:id',
                name: 'store-taxations-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/taxations/views/TaxationForm.vue')
            },
            {
                path: 'countries/add',
                name: 'store-taxations-add',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/taxations/views/TaxationForm.vue')
            },
            // Dostawy
            {
                path: 'carriers',
                name: 'store-carriers',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/carriers/views/CarriersList.vue')
            },
            {
                path: 'carriers/:id',
                name: 'store-carriers-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/carriers/views/CarrierForm.vue')
            },
            {
                path: 'carriers/add',
                name: 'store-carriers-add',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/carriers/views/CarrierForm.vue')
            },
            // Płatności
            {
                path: 'payments',
                name: 'store-payments',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/payments/views/PaymentsList.vue')
            },
            {
                path: 'payments/:id',
                name: 'store-payments-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/payments/views/PaymentForm.vue')
            },
            {
                path: 'payments/add',
                name: 'store-payments-add',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/payments/views/PaymentForm.vue')
            },
            // Kalendarz
            {
                path: 'calendar',
                name: 'store-calendar-entries',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/calendar-entries/views/CalendarEntriesList.vue')
            },
            {
                path: 'calendar/:id',
                name: 'store-calendar-entries-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/calendar-entries/views/CalendarEntriesFrom.vue')
            },
            {
                path: 'calendar/add',
                name: 'store-calendar-entries-add',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/calendar-entries/views/CalendarEntriesFrom.vue')
            },
            // Sklepy
            {
                path: 'shops',
                name: 'store-shops',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/shops/views/ShopsList.vue')
            },
            {
                path: 'shops/:id',
                name: 'store-shops-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/shops/views/ShopForm.vue')
            },
            {
                path: 'shops/add',
                name: 'store-shops-add',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/shops/views/ShopForm.vue')
            },
            // Kategorie
            {
                path: 'categories',
                name: 'store-categories',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/categories/views/CategoriesList.vue'),
                children: [
                    {
                        path: 'add/:folderId',
                        props: true,
                        name: 'store-categories-add',
                        meta: { auth: true },
                        component: () => import('@/modules/store/catalog/categories/views/CategoryForm.vue')
                    },
                    {
                        path: ':id',
                        props: true,
                        name: 'store-categories-edit',
                        meta: { auth: true, model: "Ideo.Core.Data.Model.CmsPage" },
                        component: () => import('@/modules/store/catalog/categories/views/CategoryForm.vue')
                    }
                ]
            },
            // Kolekcje
            {
                path: 'collections',
                name: 'store-collections',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/collections/views/CollectionsList.vue')
            },
            {
                path: 'collections/:id',
                name: 'store-collections-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/collections/views/CollectionForm.vue')
            },
            {
                path: 'collections/add',
                name: 'store-collections-add',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/collections/views/CollectionForm.vue')
            },
            // Produkty
            {
                path: 'products',
                name: 'store-products',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/products/views/ProductsList.vue')
            },
            {
                path: 'products/:id',
                name: 'store-products-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/products/views/ProductForm.vue')
            },
            {
                path: 'products/add',
                name: 'store-products-add',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/products/views/ProductForm.vue')
            },
            // Etykiety produktów
            {
                path: 'labels',
                name: 'store-labels',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/labels/views/LabelsList.vue')
            },
            {
                path: 'labels/:id',
                name: 'store-labels-edit',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/labels/views/LabelForm.vue')
            },
            {
                path: 'labels/add',
                name: 'store-labels-add',
                meta: { auth: true },
                component: () => import('@/modules/store/catalog/labels/views/LabelForm.vue')
            },
            // Cenniki
            {
                path: 'price-lists',
                name: 'store-price-lists',
                meta: { auth: true },
                component: () => import('@/modules/store/settings/price-lists/views/PriceList.vue'),
            },
        ]
    }
];
